var exports = {
  "K": "RecentMentionsPage.module__icon___MjBSRj",
};

module.exports = exports;
